import { StatusChip } from "components/StatusChip";
import { Summon } from "types";

interface SummonProps {
  summonData: Summon;
}

export default function SummonConfirmationStatus({ summonData }: SummonProps) {
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm space-y-4">
      <h3 className="text-base font-semibold text-gray-800">
        Summon Confirmed By
      </h3>

      <div className="flex items-center justify-between border-t pt-3">
        <span className="text-sm text-gray-600">Coordinator</span>
        <StatusChip
          status={summonData?.cordinator_confirmed ? "Confirmed" : "Pending"}
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-600">Accused</span>
        <StatusChip
          status={summonData?.accused_confirmed ? "Confirmed" : "Pending"}
        />
      </div>
    </div>
  );
}
